import { BoothtargetTable } from "./booth-target-table";
import { useEffect, useState } from "react";
import { EventsApiService } from "features/events/api/events-api.service";
import { message } from "antd";

export const BoothTargetValueView = ({ id }: any) => {
   
    const [state,setSate]=useState<any>('')
    const payload:any={
        EventId:id,
        TargetValue:null
    }
    const fetchdata=async()=>{
      try {
        const response=await EventsApiService().updatetarget(payload) 
            setSate(response)
      } catch (error:any) {
        message.error(error);
      }
    }
    
    useEffect(()=>{
      fetchdata()
    },[])
    
return (
        <>
            <BoothtargetTable
                data={state}
                refetch={fetchdata}
            />
        </>
    )
}